// extracted by mini-css-extract-plugin
export default {"container":"container--MxpSX","markerAnimationScale":"markerAnimationScale--QyG5C"};